import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import Retention from './Retention'
import Archival from './Archival'
import LegalHeld from './LegalHold'
import { useSettingsData } from '../../../../hooks/getSettingsData'
import { InfoCard2 } from '../../../widgets/components/UI/InfoCard2'

const Policies = () => {
  const { formatMessage } = useIntl()

  const [sidebar, setSidebar] = useState(1)
  const sidebarOptions = [{ title: 'Retention' }, { title: 'Archival' }, { title: 'Legal Hold' }]
  const handleSidebarClick = (index: any) => {
    setSidebar(index + 1)
  }
  const { settingsData, fileLimits2, setFileLimits2,aiEmailLoading,fetchAiEmailDataWithoutLoader } = useSettingsData()

  return (
    <div>
      <div className='mt-4'>
        {sidebar === 1 &&
          <InfoCard2 title={'Configuring Retention Policies for Your Records'} desc={`This page allows you to set up retention periods for different departments, roles, and file types. Customize retention periods to ensure your records are archived or deleted according to your organization's policies. You can also enable extensions for specific files and define how long legal holds remain active.`} slug={'https://help.recordskeeper.ai/en/articles/10410293-how-to-configure-retention-policies-for-your-records-on-recordskeeper-ai'} />
        }
        {sidebar === 2 &&
          <InfoCard2 title={'Managing Document Archival & Deletion'} desc={`This page allows you to configure how documents are handled after their retention period ends. Choose to either delete or archive documents and set up notifications to warn administrators before deletion occurs. You can also define how long archived documents will be stored before being permanently deleted.`} slug={'https://help.recordskeeper.ai/en/articles/10410364-how-to-manage-document-archival-and-deletion-of-your-records-on-recordskeeper-ai'} />
        }
        {sidebar === 3 &&
          <InfoCard2 title={'Managing Legal Holds for Documents'} desc={`This page allows you to enable and configure legal holds on documents to prevent them from being modified or deleted. Set which roles have permission to apply legal holds and define the maximum duration a legal hold can be applied. In cases where a retention period conflicts with a legal hold, the longer period will apply to ensure compliance.`} slug={'https://help.recordskeeper.ai/en/articles/10410388-how-to-manage-legal-holds-for-your-documents-on-recordskeeper-ai'} />
        }
      </div>
      <div className='d-flex flex-md-row flex-column mb-8'>
        <div className='sidebar-investor-db col-md-1 d-none d-md-flex'>
          {sidebarOptions.map((sideTabs, index) => (
            <ul
              key={index}
              className='text-muted text-active-primary d-md-flex flex-column d-none align-items-left p-0 m-0 cursor-pointer'
            >
              <li
                className={`nav-link text-active-primary py-3 ps-3 d-flex align-items-center ${sidebar === index + 1
                  ? 'border-top-0 border border-bottom-0 border-right-0 border-left-3 border-primary text-primary border-5'
                  : ''
                  }`}
                onClick={() => handleSidebarClick(index)}
              >
                {formatMessage({ id: sideTabs.title })}
              </li>
            </ul>
          ))}
        </div>
        <div className='mb-2 sidebar-investor-db col-md-1 d-flex d-md-none' style={{ width: '100%' }}>
          <div
            className='d-md-none d-flex'
            style={{
              display: 'flex',
              overflowX: 'scroll',
              whiteSpace: 'nowrap',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}
          >
            {sidebarOptions.map((sideTabs, index) => (
              <ul
                key={index}
                className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent mt-0 flex-nowrap mobile-tab-both my-md-0 mb-2 d-md-none'
                style={{ display: 'flex', flexWrap: 'nowrap' }}
              >
                <li
                  className={`nav-link text-active-primary py-3 ps-3 d-flex align-items-center ${sidebar === index + 1
                    ? 'border-top-0 border border-left-0 border-right-0 border-bottom-3 border-primary text-primary border-5'
                    : ''
                    }`}
                  onClick={() => handleSidebarClick(index)}
                >
                  {formatMessage({ id: sideTabs.title })}
                </li>
              </ul>
            ))}
          </div>
        </div>
        <div className='rounded-2 bg-white p-4 w-100'>
          {sidebar === 1 && (
            <Retention
              fileLimits2={fileLimits2}
              setFileLimits2={setFileLimits2}
              aiEmailData={settingsData}
              aiEmailLoading={aiEmailLoading}
            />
          )}
          {sidebar === 2 && <Archival aiEmailData={settingsData}  aiEmailLoading={aiEmailLoading} fetchAiEmailDataWithoutLoader={fetchAiEmailDataWithoutLoader}/>}
          {sidebar === 3 && <LegalHeld aiEmailData={settingsData}  aiEmailLoading={aiEmailLoading} fetchAiEmailDataWithoutLoader={fetchAiEmailDataWithoutLoader}/>}
        </div>
      </div>
    </div>
  )
}

export default Policies
